import { Injectable } from '@angular/core';

import { FsApi } from '@firestitch/api';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { SessionService } from './session.service';
import { SigninService } from './signin.service';


@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(
    private _signinService: SigninService,
    private _sessionService: SessionService,
    private _api: FsApi,
  ) { }

  public emailExists(
    email: string,
  ): Observable<boolean> {
    return this._api.post('auth/signin/exists', {
      email,
    }, {
      key: 'exists',
    });
  }

  public verify(password): Observable<any> {
    return this._api.post('auth/verify', { password });
  }

  public reloadPermissions(): Observable<any> {
    return this._api.get('auth/permissions')
      .pipe(
        tap((permissions) => {
          this._sessionService.permissions(permissions);
        }),
      );
  }

  public impersonate(accountId: number): Observable<any> {
    return this._api.post('auth/impersonate', { accountId })
      .pipe(
        tap((response) => this._signinService.setSession(response)),
      );
  }

}
